/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router';
// const lazyLoading = (name) => process.env.NODE_ENV === 'development' ?
//   () => import(`./views/${name}.vue`) : require(`./views/${name}.vue`);
const DefaultIndex = {template: '<router-view :key="$route.path"></router-view>'};

function lazyLoading(name) {
  return function () {
    return import(`./views/${name}.vue`);
  };
}

Vue.use(Router);

import Container from './components/layout/Container.vue';
import App from './App.vue';

export default new Router({
    base: '/admin/',
    mode: 'history',
    routes: [
        {
            path: '/login',
            component: lazyLoading('Login'),
            meta: {
                title: '无权限',
            },
        },
        {
            path: '/print',
            component: lazyLoading('Print'),
            meta: {
                title: '预约票据',
            },
        },
        {
            path: '/preview',
            component: lazyLoading('Sell/Print'),
            meta: {
                title: '合同预览',
            },
        },
        {
            path: '/ticket',
            component: lazyLoading('Sell/TicketPrint'),
            meta: {
                title: '结账单',
            },
        },
        {
            path: '/',
            component: Container,
            redirect: {
                name: 'Board',
            },
            children: [
                {
                    name: 'Board',
                    path: 'board',
                    meta: {
                        title: '仪表盘',
                        ico: 'iconfont icon-fitness-yibiaopan1',
                    },
                    redirect: {
                        name: 'Dash.Board',
                    },
                    component: App,
                    children: [
                        {
                            name: 'Dash.Board',
                            path: '/',
                            component: lazyLoading('Board/List'),
                        },
                    ],
                }, {
                    name: 'Reception',
                    path: 'reception',
                    meta: {
                        title: '前台',
                        ico: 'iconfont icon-fitness-bianji'
                    },
                    redirect: {
                        name: 'Reception',
                    },
                    component: App,
                    children: [
                        {
                            name: 'Reception',
                            path: '/',
                            component: lazyLoading('Reception/List'),
                        },
                    ],
                }, {
                    name: 'Client',
                    path: 'client',
                    meta: {
                        title: '客户',
                        ico: 'iconfont icon-fitness-kehu',
                    },
                    redirect: {
                        name: 'Client.Index',
                    },
                    component: App,
                    children: [
                        {
                            name: 'Client.Index',
                            path: 'list',
                            component: lazyLoading('Client/Index'),
                        },
                        {
                            name: 'Client.Show',
                            path: 'show/:id',
                            component: lazyLoading('Client/Show'),
                        },
                    ],
                }, {
                    name: 'Course',
                    path: 'course',
                    meta: {
                        title: '课程',
                        ico: 'iconfont icon-fitness-custom-form',
                    },
                    redirect: {
                        name: 'Course',
                    },
                    component: App,
                    children: [
                        {
                            name: 'Course',
                            path: '/',
                            component: lazyLoading('Course/List'),
                        },
                    ],
                }, {
                    name: 'Sell',
                    path: 'sell',
                    meta: {
                        title: '售卖',
                        ico: 'iconfont icon-fitness-gouwuche'
                    },
                    redirect: {
                        name: 'Sell.Index',
                    },
                    component: App,
                    children: [
                        {
                            name: 'Sell.Index',
                            path: 'index',
                            component: lazyLoading('Sell/Index'),
                        },
                        {
                            name: 'Sell.Show',
                            path: 'show/:id',
                            component: lazyLoading('Sell/Show'),
                        },
                    ],
                }, {
                    name: 'Store',
                    path: 'store',
                    meta: {
                        title: '门店',
                        ico: 'iconfont icon-fitness-mendianguanli'
                    },
                    redirect: {
                        name: 'Store.List',
                    },
                    component: App,
                    children: [
                        {
                            name: 'Store.List',
                            path: 'list',
                            component: lazyLoading('Store/List'),
                        },{
                            name: 'Store.Edit',
                            path: 'show/:id',
                            component: lazyLoading('Store/Edit'),
                        },{
                            name: 'Store.Contract',
                            path: 'show/:id',
                            component: lazyLoading('Store/Contract'),
                        },{
                            name: 'Store.Place',
                            path: 'place/:id',
                            component: lazyLoading('Store/Place'),
                        },
                    ],
                }, {
                    name: 'Staff',
                    path: 'staff',
                    meta: {
                        title: '员工',
                        ico: 'iconfont icon-fitness-zhengchangkehu',
                    },
                    redirect: {
                        name: 'Staff.List',
                    },
                    component: App,
                    children: [
                        {
                            name: 'Staff.List',
                            path: 'list',
                            component: lazyLoading('Staff/List'),
                        },{
                            name: 'Staff.Show',
                            path: 'show/:id',
                            component: lazyLoading('Staff/Show'),
                        },
                    ],
                }, {
                    name: 'Stats',
                    path: 'stats',
                    meta: {
                        title: '统计',
                        ico: 'iconfont icon-fitness-tongji1',
                    },
                    redirect: {
                        name: 'Stats.List',
                    },
                    component: App,
                    children: [
                        {
                            name: 'Stats.List',
                            path: 'stats',
                            component: lazyLoading('Stats/List'),
                        },
                    ],
                }, {
                    name: 'Finance',
                    path: 'finance',
                    meta: {
                        title: '财务',
                        ico: 'iconfont icon-fitness-caiwuguanli',
                    },
                    redirect: {
                        name: 'Finance.List',
                    },
                    component: App,
                    children: [
                        {
                            name: 'Finance.List',
                            path: '/',
                            component: lazyLoading('Finance/List'),
                        },
                    ],
                }, {
                    name: 'Upload',
                    path: 'upload',
                    component: lazyLoading('Upload'),
                }, {
                    name: 'Modify',
                    path: '/modify-phone',
                    component: lazyLoading('Staff/Modify'),
                }, {
                    name: 'Measurement',
                    path: '/measurement',
                    component: lazyLoading('Measurement/Index'),
                }, {
                    name: 'MyProfile',
                    path: 'my-profile',
                    component: lazyLoading('MyProfile'),
                }, {
                    path: '/403',
                    component: lazyLoading('403'),
                }, {
                    name: 'Setting.List',
                    path: 'setting',
                    component: lazyLoading('Setting/List'),
                }, {
                    name: 'Message.List',
                    path: 'message',
                    component: lazyLoading('Message/List'),
                },
            ],
        }, {
            path: '*',
            redirect: '/',
        },
    ],
});
